<template>
    <v-container fluid class="b-container">
        <router-view></router-view>
    </v-container>
</template>

<script>
export default {
    name: "GeneralSettings",

    data() {
        return {};
    },

    computed: {

        lang() {
            return this.$route.params.lang;
        },

    },
};
</script>

<style lang="scss">
.dashed {
    border: 1px dashed grey;
    border-radius: 10px;
}

.relative {
    position: relative;
}

.theme--light.v-tabs > .v-tabs-bar {
    width: 100%;
}

.v-tabs-bar.v-item-group > * {
    width: 100%;
}

.v-slide-group__content {
    width: 100%;
}

.my-subscription {
    background-color: #2a3042;
    color: white !important;
    border-radius: 5px 5px 0px 0px;
}
</style>
